import z from "zod";

export const projectViewFormSchema = z.object({
  // Visual do Projeto
  presentationMaterialsLink: z.string().url("o campo deve ser um link"),
  videoTeaserLink: z.string().url("o campo deve ser um link"),

  // Capa do Projeto
  coverImage: z.any()
});

export type ProjectViewFormData = z.infer<typeof projectViewFormSchema>;